export * from './page-header/page-header.module';
export * from './stat/stat.module';



// WEBPACK FOOTER //
// ./src/app/shared/modules/index.ts